import { render, staticRenderFns } from "./AuditUserHistory.vue?vue&type=template&id=2fa99116&scoped=true"
import script from "./AuditUserHistory.vue?vue&type=script&lang=js"
export * from "./AuditUserHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa99116",
  null
  
)

export default component.exports